module.exports = __webpack_public_path__ + "img/gold-badge.4e4e8d4b.png";